import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import CompMeta from '../../meta/LowCodeComponents/Search';
import { getPropsFromMeta } from "../../utils"

/**
 * @class NCSearch
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCSearch
 * @label 查询区
 *
 */
class NCSearch extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
        * @title 区域编码
        * @description 区域编码
        */
        moduleId: PropTypes.string.isRequired,
        /**
         * @title 是否显示查询按钮
         * @description 是否显示查询按钮
         */
        showSearchBtn: PropTypes.bool,
        /**
         * @title 是否显示高级查询按钮
         * @description 是否显示高级查询按钮
         */
        smshowAdvBtn: PropTypes.bool,
        /**
         * @title 是否显示清空按钮
         * @description 是否显示清空按钮
         */
        showClearBtn: PropTypes.bool,
        /**
         * @title 是否显示查询方案按钮
         * @description 是否显示查询方案按钮
         */
        showAdvSearchPlanBtn: PropTypes.bool,
        /**
         * @title 隐藏候选条件
         * @description 隐藏候选条件
         */
        hideSearchCondition: PropTypes.bool,
        /**
        * @title 隐藏查询按钮区域
        * @description 隐藏查询按钮区域
        */
        hideBtnArea: PropTypes.bool,
        /**
       * @title 只显示高级按钮
       * @description 只显示高级按钮
       */
        onlyShowSuperBtn: PropTypes.bool,
        /**
        * @title 在查询区只显示高级查询面板
        * @description 在查询区只显示高级查询面板
        */
        onlyShowAdvArea: PropTypes.bool,
        /**
       * @title 在查询区只显示高级查询模态框
       * @description 在查询区只显示高级查询模态框
       */
        onlyShowModal: PropTypes.bool,
        /**
        * @title 是否启用查询区缓存
        * @description 是否启用查询区缓存
        */
        useCache: PropTypes.bool,
        /**
       * @title 是否同步渲染高级查询区
       * @description 是否同步渲染高级查询区
       */
        isSynInitAdvSearch: PropTypes.bool,
        /**
        * @title 只显示方案列表和高级查询
        * @description 只显示方案列表和高级查询
        */
        onlyShowPlan: PropTypes.bool,
        /**
       * @title 高级查询模态框标题
       * @description 高级查询模态框标题
       */
        searchModalTitle: PropTypes.bool,
        /**
        * @title 多个查询组件同时存在时，用来标识当前查询组件
        * @description 多个查询组件同时存在时，用来标识当前查询组件
        */
        currentSearch: PropTypes.bool,
        /**
       * @title 默认不是模板顺序，如果是模板顺序，则取消必填项优先的逻辑
       * @description 默认不是模板顺序，如果是模板顺序，则取消必填项优先的逻辑
       */
        isTemplateOrder: PropTypes.bool,
        /**
        * @title 是否可见
        * @description 是否可见
        */
        visible: PropTypes.bool,
    }
    static defaultProps = {
        showSearchBtn: true,
        showAdvBtn: true,
        showClearBtn: true,
        showAdvSearchPlanBtn: true,
        hideSearchCondition: false,
        hideBtnArea: false,
        onlyShowSuperBtn: false,
        onlyShowAdvArea: false,
        onlyShowModal: false,
        useCache: true,
        isSynInitAdvSearch: false,
        onlyShowPlan: false,
        currentSearch: true,
        isTemplateOrder: false
    }
    static getCompMeta = () => {
        return CompMeta;
    }

    renderSearch = () => {
        const { search: { NCCreateSearch }, moduleId, config = {}, getButtonActionsByKey } = this.props;
        let { clickSearchBtn } = config;
        //没有注册search按钮事件，就执行预置动作查询
        // if (!clickSearchBtn) {
        //     config.clickSearchBtn = () => {
        //         //------预置动作逻辑-------
        //         //获取查询按钮预置动作处理函数数组
        //         let btnActionHandlers = getButtonActionsByKey({ ...this.props, btnCode: "search" });
        //         //执行预置动作
        //         btnActionHandlers.forEach(handler => handler());
        //     }
        // }

        const configProps = getPropsFromMeta(this.props, NCSearch.getCompMeta());
        let searchVdom = (
            <div className="lc-drop-area nc-bill-search-area">
                {NCCreateSearch(moduleId, Object.assign(configProps, config))}
                {/* {NCCreateSearch(moduleId, {})} */}
            </div>
        );
        return searchVdom;

    }
    render() {
        return (
            <Fragment>
                {this.renderSearch()}
            </Fragment>
        )
    }
}
export default NCSearch;
